<script setup lang="ts">
import type { License } from "~/modules/license/models/License.interface";
import { LicenseStatus } from "~/modules/license/models/LicenseStatus.enum";
import { getLicenseStatus } from "~/modules/license/utils/getLicenseStatus";

const { t } = useI18n();

const props = defineProps<{
  license: License;
}>();

const licenseStatusComputed = computed(() =>
  props.license ? getLicenseStatus(props.license) : null,
);

const licenseStatusClass = computed(() => {
  const licenseStatusClass = [];

  switch (licenseStatusComputed.value) {
    case LicenseStatus.ACTIVE:
      licenseStatusClass.push("text-primary-700");
      break;
    case LicenseStatus.WARNING:
      licenseStatusClass.push("text-warning-700");
      break;
    case LicenseStatus.EXPIRED:
      licenseStatusClass.push("!text-error-700");
  }

  return licenseStatusClass;
});
</script>
<template>
  <div class="font-semibold pr-3 text-grey-700">
    {{ t("license.status.title") }}
  </div>
  <div :class="licenseStatusClass">
    <lxc-badge
      v-if="licenseStatusComputed === LicenseStatus.ACTIVE"
      type="primary"
      text-white
    >
      {{ t("license.status.active") }}
    </lxc-badge>
    <lxc-badge
      v-else-if="licenseStatusComputed === LicenseStatus.WARNING"
      type="warning"
      text-white
    >
      {{ t("license.status.warning") }}
    </lxc-badge>
    <lxc-badge
      v-else-if="licenseStatusComputed === LicenseStatus.EXPIRED"
      type="danger"
      text-white
    >
      {{ t("license.status.expired") }}
    </lxc-badge>
  </div>
</template>
